<template>
  <div class="result" v-if="config.icon">
    <div>
      <a-icon class="icon" :style="{color: config.icon.color}" :type="config.icon.type" />
    </div>
    <div class="title">{{ config.label }}</div>
    <div class="description" v-html="config.description"></div>
    <div class="content">
      <h3>账号信息</h3>
      <a-row v-if="user" type="flex" :gutter="100">
        <a-col>姓名：{{ user.name }}</a-col>
        <a-col>手机号：{{ user.mobile }}</a-col>
        <a-col>邮箱： {{ user.email }}</a-col>
        <a-col>院系/部门： {{ user.departments && user.departments.filter(item=>item).join(' / ') }}</a-col>
      </a-row>
      <h3 style="margin-top: 30px">管理员信息：</h3>
      <a-row v-if="college && college.contact_person" type="flex" :gutter="100">
        <a-col>姓名：{{ college.contact_person.name }}</a-col>
        <a-col>邮箱： {{ college.contact_person.email }}</a-col>
      </a-row>
    </div>
    <div class="action">
      <a-button @click="() => { $router.push({name: 'login'}) }">返回</a-button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Colleges } from '@/resources'

export default {
  data () {
    return {
      college: {
        contact_person: {}
      },
      user: {}
    }
  },
  computed: {
    config () {
      const vm = this
      let icon, label, description
      const state = vm.user.state
      if (state) {
        switch (state) {
          case 'applying':
            label = '等待审核'
            description = `<span style="font-weight: bold">身份审核通过后即可登录系统</span> 别忘了前往邮箱进行邮箱激活哦`
            icon = {
              color: '#66ccff',
              type: 'clock-circle'
            }
            break
          case 'rejected':
            label = '认证失败'
            description = `很抱歉，您的<span style="color: #f786ac">身份认证失败</span>，<br> 没有权限登录和使用本系统，<br>如有疑问，请联系系统管理员。`
            icon = {
              color: '#ff424e',
              type: 'close-circle'
            }
            break
          case 'accepted':
            label = '注册成功'
            description = `激活邮件已发送到您的邮箱，请注意查收`
            icon = {
              color: '#52c41a',
              type: 'check-circle'
            }
            break
        }
      }

      return {
        icon,
        label,
        description
      }
    }
  },
  async created () {
    const params = this.$route.params
    if (Object.keys(params).length <= 0) {
      this.$router.replace({ name: 'login' })
    }
    this.SetUserLayoutHead(false)
    this.user = params.user
    const { college } = await Colleges.find(this.user.college && this.user.college.id)
    this.college = college
  },
  methods: {
    ...mapActions(['SetUserLayoutHead']),

    closeWindow () {
      window.close()
    }
  },
  beforeDestroy () {
    const vm = this
    vm.SetUserLayoutHead(true)
  }
}
</script>

<style scoped lang="less">
.result {
  text-align: center;
  margin: 0 auto;
  padding: 24px 0 8px;

  .icon {
    font-size: 72px;
    line-height: 72px;
    margin-bottom: 24px;
  }
  .success {
    color: #52c41a;
  }
  .error {
    color: red;
  }
  .title {
    font-size: 24px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
    line-height: 32px;
    margin-bottom: 16px;
  }
  .description {
    font-size: 14px;
    line-height: 22px;
    color: rgba(0, 0, 0, 0.45);
    margin-bottom: 24px;
  }
  .content {
    width: 80%;
    background: #fafafa;
    padding: 24px 40px;
    border-radius: 2px;
    text-align: left;
    margin: 0 auto;
  }
  .action {
    margin-top: 32px;
  }
}
</style>
